import { atom } from "recoil";

export type ISignininRoutes =
  | "phone"
  | "chooseMethod"
  | "otpVerify"
  | "face-recognize";

export const SignInActiveStep = atom<ISignininRoutes>({
  key: "signin-activestep",
  default: "phone",
});
export const SignnPropsState = atom<any>({
  key: "signin-PropsState",
  default: {},
});

export const FacesState = atom<any>({
  key: "faces-state",
  default: [],
});

export const FacesPipelineState = atom<any>({
  key: "faces-pipeline-state",
  default: {},
});

export const AuthenticatedState = atom<boolean>({
  key: "faces-state-athenticated",
  default: false,
});

export const AuthenticatorNameState = atom<string>({
  key: "faces-state-athenticator-name",
  default: "Unknown",
});
